// extracted by mini-css-extract-plugin
export default {"wrap":"HomePageAdvertisingBanner_wrap__cpgXR"};